import type { TestCategory } from "@test-platform/shared";
import { TEST_CATEGORIES } from "@test-platform/shared/catalog";

export function readExplorerFilters(params: { get(name: string): string | null }) {
  const categoryParam = params.get("cat");
  const category = TEST_CATEGORIES.find(({ id }) => id === categoryParam)?.id ?? null;
  const query = params.get("q") ?? "";
  const normalizedQuery = query.trim().toLowerCase();
  const shortOnly = params.get("duration") === "1";
  return {
    category,
    query,
    normalizedQuery,
    shortOnly,
    isBrowsing: normalizedQuery.length > 0 || category !== null || shortOnly,
  };
}

export function filterExplorerTests<
  T extends { title: string; description: string; category: TestCategory; questionCount: number },
>(tests: readonly T[], filters: ReturnType<typeof readExplorerFilters>): T[] {
  return tests.filter((test) =>
    (!filters.category || test.category === filters.category) &&
    (!filters.normalizedQuery ||
      test.title.toLowerCase().includes(filters.normalizedQuery) ||
      test.description.toLowerCase().includes(filters.normalizedQuery)) &&
    (!filters.shortOnly ||
      (test.questionCount > 0 && Math.max(1, Math.round(test.questionCount / 6)) === 1)),
  );
}
